import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { UPDATE_PRODUCT_INFORMATION_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateProductInformationRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {};

  url = UPDATE_PRODUCT_INFORMATION_URL;

  constructor(requestBody, paramList) {
    super();
    this.body = { ...this.body, ...requestBody };
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
